<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('providerPage.providersList')}}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2 px-3">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       type="text"
                                       v-model="filterModel.name"
                                       :placeholder="$t('shared.providerName')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 px-3">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       v-model="filterModel.taxNumber"
                                       type="text" :placeholder="$t('shared.taxNumber')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 px-3">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       v-model="filterModel.accreditationNumber"
                                       type="text" :placeholder="$t('shared.accreditationNumber')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 px-3">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       type="text"
                                       v-model="filterModel.enterpriseUnifiedNumber"
                                       :placeholder="$t('shared.enterpriseUnifiedNumber')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-1 mt-1">
                            <button @click="reset" class="btn btn-primary btn-action">{{$t('shared.reset')}}</button>
                        </div>
                    </div>
                    <template>
                        <v-data-table :headers="headers"
                                      :items="providers"
                                      :total-items="providersCount"
                                      :rows-per-page-text="$t('shared.rowsPerPage')"
                                      :rows-per-page-items='[10, 25, 50, 100]'
                                      @update:pagination="updatePaginate"
                                      class="elevation-1 table-striped">
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-center">{{ props.item.providerCode }}</td>
                                    <td class="text-center">{{ props.item.name }}</td>
                                    <td class="text-center">{{ props.item.enterpriseUnifiedNumber }}</td>
                                    <td class="text-center">{{ props.item.accreditationNumber }}</td>
                                    <td class="text-center">{{ props.item.taxNumber }}</td>

                                    <td class="text-center">{{ props.item.state }}</td>
                                    
                                    <td class="text-center">
                                        <router-link :to="'/ProviderSupport/ProviderUpdate/' + props.item.id" tag="i" class="fas fa-pencil-alt Icon_Edit"></router-link>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
</div>
